import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pop_up report_banner" }
const _hoisted_2 = { class: "pop_tit" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "btn_wrap _default _center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "pop_up_layer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.fnEvent && $setup.fnEvent(...args)))
    }, null, 512), [
      [_vShow, $props.isShow]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close_btn icon_wrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.fnEvent && $setup.fnEvent(...args)))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("img", {
          src: "img/close.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", {
          textContent: _toDisplayString($setup.state.title)
        }, null, 8, _hoisted_3)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "editor_wrap" }, [
        _createElementVNode("textarea", {
          class: "custom_scroll",
          id: "editor1",
          name: "editor1"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "submit_btn w_120",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)))
        }, "수정")
      ])
    ], 512), [
      [_vShow, $props.isShow]
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal
        }, null, 8, ["type", "title", "content", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}